import i18n from '@/i18n'

export const STATUS_COLORS = {
  normal:   '#34d399',
  caution:  '#fbbf24',
  abnormal: '#f87171',
  delay:    '#6b7280',
}

// 상태 텍스트는 이제 i18n 에서 lookup — 활성 locale 에 따라 변경
//   STATUS_TEXT 객체는 후방 호환을 위해 getter 로 유지 (변경된 locale 자동 반영)
const STATUS_KEYS = {
  normal:   'dashboard.summary.normal',
  caution:  'dashboard.summary.caution',
  abnormal: 'dashboard.summary.alarm',
  delay:    'dashboard.summary.delay',
}
export const STATUS_TEXT = new Proxy({}, {
  get(_, key) {
    const k = STATUS_KEYS[key]
    return k ? i18n.global.t(k) : key
  },
})

export const STATUS_ORDER = {
  delay:    0,
  normal:   1,
  caution:  2,
  abnormal: 3,
}

function pressureStatus(d) {
  if (d.mnp == null || d.mnp === '') return 'delay'
  if (d.content != null && d.content !== '') return 'abnormal'
  const boundary = Number(d.ref_mnp_boundary ?? d.mnp_boundary)
  const mnp = Number(d.mnp)
  if (isFinite(boundary) && isFinite(mnp)) {
    if (mnp < boundary || mnp >= boundary + 2) return 'caution'
  }
  return 'normal'
}

function leakStatus(d) {
  if (d.wave_energy == null || d.wave_energy === '') return 'delay'
  // data_stale — 조회 기준일보다 오래된 측정값. 목록을 가져오는 쪽(기준일을 아는 곳)에서
  //   leakDate.isLeakDataStale 로 판정해 심어준다. 이 함수는 순수 함수라 "무슨 날짜로
  //   조회했는지"를 알 수 없으므로 여기서 오늘 날짜를 직접 계산하면 과거 날짜 조회가 전부 미확인이 된다
  if (d.data_stale) return 'delay'
  if (typeof d._5days === 'string' && d._5days.slice(0, 5) === '1,1,1') return 'abnormal'
  // AI 판정 필드 — 원격 모니터링(m2_leak_1/list) 응답은 ai_leak_result, 누수탐지(get_geojson→leak_type) 응답은 leak_type 사용
  if (d.ai_leak_result === 'L' || d.leak_type === 'L') return 'caution'
  return 'normal'
}

export function getDeviceStatus(d) {
  if (!d) return 'delay'
  if (d.measure_type === 'leak') return leakStatus(d)
  return pressureStatus(d)
}

export function statusColor(st) { return STATUS_COLORS[st] || STATUS_COLORS.delay }
// isLeak — 누수음 지점의 caution(AI 판정=L) 은 일반 "주의" 대신 "누수의심"으로 표기 (누수탐지 모듈 전역 관례와 통일)
export function statusText(st, isLeak = false) {
  if (st === 'caution' && isLeak) return i18n.global.t('dashboard.summary.leak_caution')
  return STATUS_TEXT[st] || st
}
